import { render } from "./DebugMaterials.vue?vue&type=template&id=4561b142&scoped=true"
import script from "./DebugMaterials.vue?vue&type=script&lang=js"
export * from "./DebugMaterials.vue?vue&type=script&lang=js"

import "./DebugMaterials.vue?vue&type=style&index=0&id=4561b142&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4561b142"]])

export default __exports__